/**
 * @fileoverview Document Draft Context
 * Keeps form data in React memory so it survives page navigation.
 * Data is automatically lost when the tab closes or user logs out.
 */
import { createContext, useContext, useState, useCallback } from 'react';

const DocumentDraftContext = createContext(null);

export const useDocumentDraft = () => useContext(DocumentDraftContext);

export const DocumentDraftProvider = ({ children }) => {
    const [draft, setDraft] = useState(null);

    /**
     * Save current form state to memory
     */
    const saveDraft = useCallback((data) => {
        setDraft({
            fieldValues: data.fieldValues || {},
            recipientEmail: data.recipientEmail || '',
            recipientName: data.recipientName || '',
            freeFields: data.freeFields || [],
            selectedTemplateId: data.selectedTemplateId || null,
            issuanceMode: data.issuanceMode || 'basic',
            savedAt: Date.now(),
        });
    }, []);

    /**
     * Clear everything (on submit success or logout)
     */
    const clearDraft = useCallback(() => {
        setDraft(null);
    }, []);

    /**
     * Check if there's a saved draft
     */
    const hasDraft = !!draft;

    return (
        <DocumentDraftContext.Provider value={{ draft, saveDraft, clearDraft, hasDraft }}>
            {children}
        </DocumentDraftContext.Provider>
    );
};
